import { Component, OnInit, Input } from '@angular/core';
import { IConfig } from 'src/app/modules/core/interfaces/config';

@Component({
  selector: 'app-main-layout2',
  templateUrl: './main-layout2.component.html',
  styleUrls: ['./main-layout2.component.scss']
})
export class MainLayout2Component implements OnInit {

  @Input()
  public config: IConfig;

  constructor(
  ) { }

  ngOnInit() {
  }

}
